// Products are no longer hardcoded here — the DCR form and filters fetch the
// live master from /doctor-visits/meta/products so the dropdown always matches
// what the backend validates against (settings_products / product_master.py).

export const FEEDBACK_OPTIONS = [
  { value: "Positive", label: "Positive" },
  { value: "Neutral", label: "Neutral" },
  { value: "Negative", label: "Negative" },
  { value: "Not Available", label: "Not Available" },
];

// `export const MAX_BACKDATE_DAYS = 7;` stood here and is DELETED, not merely
// left unused (CLAUDE.md — delete the dead copy).
//
// It was a second copy of `routes_visits.MAX_BACKDATE_DAYS`, which is now the
// Director-editable `settings_field_policy.dcr_backdate_days`. Nothing imported
// this one, which is the only reason it never drifted; an exported constant
// nobody reads today is an invitation to import it into a fourth place
// tomorrow, and the day a form had imported it, one Director edit would have
// made the date picker offer dates the validator refuses — #78, for the fourth
// time, with a calendar instead of a dropdown.
//
// The window comes back on GET /doctor-visits/meta/products, from the same
// reader (`routes_settings.field_policy`) the create and edit handlers
// validate with. There is no fallback: if it cannot be loaded, block the form.



